import styles from "./TradeInUnavailable.module.scss";
import { DEPRECATED_Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { useTradeInContext } from "../../../TradeInContext";
import { MicrositeCTAUI } from "../../MicrositeCTA/MicrositeCTAUI";

const TradeInUnavailable = () => {
  const { errorMessage } = useTradeInContext();

  if (!errorMessage) return null;

  return (
    <>
      <DEPRECATED_Message
        title={errorMessage.title}
        body={errorMessage.body}
        type={errorMessage.type}
        className={styles.unavailable__error}
      />

      <div className={styles.unavailable__innerBlock}>
        <h2 className={styles.unavailable__altHeading}>
          Alternatively you could try
        </h2>
        <MicrositeCTAUI
          hasMultipleTradeInRoutes={false}
          isFullWidthMode={false}
        />
      </div>
    </>
  );
};

export default TradeInUnavailable;
